import { defineMutation, useMutation, useQueryCache } from '@pinia/colada';

import { showingsQueryKey } from '../queries/showings.query';
import showingService from '../services/showings.service';

export const useAssignShowingAgent = defineMutation(() => {
  return useMutation({
    mutation({ showingId, showingAgentId }: { showingId: string; showingAgentId: string }) {
      return showingService.assignAgent(showingId, showingAgentId);
    },
    async onSuccess() {
      const queryCache = useQueryCache();

      await queryCache.invalidateQueries({ key: [showingsQueryKey] });
    },
  });
});
